import MUIDataTable from "mui-datatables";
import { Vocabulary } from "../../Utils/Vocabulary";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
  Tooltip,
  Toolbar,
  Chip,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeProvider } from "@emotion/react";
import { getMuiTheme } from "../../Utils/globalStyleTables";
import { getData } from "../../Services/getData";
import { urlEnum, localUrlEnum } from "../../Utils/urlEnum";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import {
  AutocompleteUser,
  ClientMessageModel,
  StatusModel,
} from "../../Models/Models";
import {
  Nomenclator,
  VehicleBrandModel_Model,
} from "../../Models/VehicleModel";
import moment, { Moment } from "moment";
import {
  anafFormatDate,
  europeanDate,
  europeanDateWithTime,
} from "../../Utils/formatDate";
import { postData } from "../../Services/postData";
import {
  ClientMessageSource,
  DEFAULT_MAX_NUMBER_OF_MESSAGES,
  PER_PAGE_DEFAULT,
  Settings,
  clientMessagesStatus,
  componentNames,
  tableLayoutOnMobile,
} from "../../Utils/Constants";
import {
  exportTable,
  getFirstVehicleCreatedAt,
  isMobile,
} from "../../Utils/utils";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TuneIcon from "@mui/icons-material/Tune";
import DinamicTabs from "../DinamicTabs";
import { clientMessagesType } from "../../Utils/autocompleteEnum";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import LegendComponent from "../LegendComponent";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { CacheContext } from "../../Context/cacheContext";
// import WhatsAppIcon from "@mui/icons-material/WhatsApp";
// import SendIcon from "@mui/icons-material/Send";

type FollowUpFilter = boolean;

type FormStateModel = {
  vin: string | null;
  brand: Nomenclator | null;
  model: VehicleBrandModel_Model | null;
  status: StatusModel[] | undefined;
  clientName: string | null;
  order: string | undefined;
  page: number;
  perPage: number;
  count: number;
  startDate: Moment | string;
  endDate: Moment | string;
  user: AutocompleteUser | undefined | null;
  followUpFilter: FollowUpFilter;
  sortField: string;
  accesForAllMessages?: any;
};
export interface MainTableProps {
  children?: React.ReactNode;
  index?: number;
  value?: number;
}

export default function ClientMessages(props: any) {
  const { tabsLabelsArray, value, status } = props;
  const navigate = useNavigate();
  const [messages, setMessages] = useState<Array<ClientMessageModel>>([]);
  const [assignedUsers, setAssignedUsers] = useState<Array<AutocompleteUser>>([]);
  const [openAccordion, setOpenAccordion] = useState(false);
  const [messagesCount, setMessagesCount] = useState(0);
  const userId = localStorage.getItem("useId");
  const cacheContext = useContext(CacheContext);
  const minDate = getFirstVehicleCreatedAt(cacheContext.cache);

  const [formState, setFormState] = useState<FormStateModel>({
    vin: "",
    brand: null,
    model: null,
    status: undefined,
    user: null,
    clientName: "",
    order: "desc",
    page: 0,
    perPage: PER_PAGE_DEFAULT,
    count: 0,
    startDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
    followUpFilter: false,
    sortField: "created_at",
  });

  function TabPanel(props: MainTableProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography component={"span"} variant={"body2"}>
              {children}
            </Typography>
          </Box>
        )}
      </div>
    );
  }

  /**
   * get messages on change
   */
  useEffect(() => {
    getMessages();
  }, [
    formState.page,
    formState.perPage,
    props.value,
    formState.brand,
    formState.model,
    formState.order,
    formState.status,
    formState.user,
    formState.startDate,
    formState.endDate,
    formState.followUpFilter,
    formState.sortField,
  ]);

  /**
   * get messages form server and override local messages
   */
  async function getMessages(startDate?: any, endDate?: any) {
    const url = formAPIClientMessagesUrl(startDate, endDate);

    try {
      const response = await getData(url);
      setMessages(response.data.messages);
      setMessagesCount(response.data.numberOfUnreadMessages);
      setAssignedUsers(response.data.assignedUsers);
      props.setUnassignedMessagesCount(response.data.numberOfUnseenMessages);

      const newForm = Object.assign({}, formState);
      newForm.count = response.data.numberOfMessages;
      newForm.startDate = startDate ? startDate : formState.startDate;
      newForm.endDate = endDate ? endDate : formState.endDate;
      setFormState(newForm);
    } catch (e) {
      setMessages([]);
    }
  }

  /**
   * get the api url
   * @returns string
   */
  function formAPIClientMessagesUrl(startDate?: any, endDate?: any) {
    const statusCode =
      props.status === "" ? tabsLabelsArray[0].code : props.status;

    const statusIds: any[] = [];
    if (formState.status) {
      formState.status.forEach((status) => {
        statusIds.push(status.id);
      });
    }
    return `${urlEnum.clientMessages}?type=${
      clientMessagesType.contactMessage
    }&page=${formState.page}&perPage=${formState.perPage}&vin=${
      formState.vin
    }&brand_id=${formState.brand?.id || ""}&model_id=${
      formState.model?.id || ""
    }&clientName=${formState.clientName}&order=${
      formState.order
    }&startDate=${moment(startDate ? startDate : formState.startDate).format(
      "YYYY-MM-DD",
    )}&endDate=${moment(endDate ? endDate : formState.endDate).format(
      "YYYY-MM-DD",
    )}&firstSeenUser=${userId}&status=${statusCode}&filterStatus=${statusIds}&filterUser=${
      formState.user?.id
    }&followUpFilter=${formState.followUpFilter ? 1 : 0}&sortField=${formState.sortField}`;
  }

  /**
   * set the id of the current user as the one that has seen the message
   * @param messageId
   */
  async function sendFirstSeenBy(messageId: number) {
    const url = `${urlEnum.clientMessages}/${messageId}`;
    const response = await postData(url);
    const s = messages.find((message) => message.id === response?.data.id);
    if (s) {
      s.first_seen_user_id = response?.data?.first_seen_user_id;
      setMessages(messages.slice());
    }
  }

  /**
   * Mark the next pending follow-up for a message as contacted/completed.
   */
  async function completeFollowUp(event: React.MouseEvent, followUpId: number, messageId: number) {
    event.stopPropagation();
    try {
      await postData(`${urlEnum.leadFollowUps}/${followUpId}/complete`, {});
      setMessages((prev) =>
        prev.map((msg) =>
          msg.id === messageId
            ? { ...msg, next_follow_up: { ...msg.next_follow_up, completed: true } }
            : msg,
        ),
      );
    } catch {
      // error handled by postData
    }
  }

  /**
   * changes textfields values
   * @param event
   */
  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    setFormState({
      ...formState,
      [event.target.name]: event.target.value,
      page: 0,
    });
  }

  /**
   * changes textfields values
   * @param event
   */
  function onChangeStartDate(event: any) {
    const newFormState = Object.assign({}, formState);
    newFormState.startDate = event?._d;
    getMessages(event?._d, formState.endDate);
  }

  /**
   * changes textfields values
   * @param event
   */
  function onChangeEndDate(event: any) {
    const newFormState = Object.assign({}, formState);
    newFormState.endDate = event?._d;
    getMessages(formState.startDate, event?._d);
  }

  function onTextFieldKeyUp(e: React.KeyboardEvent) {
    if (e.key === "Enter") {
      getMessages();
    }
  }

  function onFilterBlur() {
    getMessages();
  }

  /**
   * Navigate to the lead detail page. Marks as seen if not yet seen.
   */
  function openMessage(rowIndex: number) {
    const crtMsg: ClientMessageModel = messages[rowIndex];
    if (!crtMsg.first_seen_user_id) {
      sendFirstSeenBy(crtMsg.id);
    }
    navigate(`${localUrlEnum.leadDetail}/${crtMsg.id}`, { state: { lead: crtMsg } });
  }

  // /**
  //  *
  //  * @param rowIndex
  //  */
  // function sendTemplate(phone: any) {
  //   sendWhatsappTemplate(phone);
  // }
  // /**
  //  *
  //  * @param rowIndex
  //  */
  // function sendText(phone: any) {
  //   sendWhatsappText(phone);
  // }

  // Badge styles for Lead-uri source
  const leadBadgeStyles = {
    container: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "flex-start",
      gap: 4,
    },
    badge: {
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#FF6633",
      color: "#fff",
      fontSize: 10,
      fontWeight: 600,
      padding: "2px 8px",
      borderRadius: 4,
      letterSpacing: "0.3px",
      lineHeight: 1.4,
    },
  };

  // columns for My Messages
  const columns = [
    {
      name: "name",
      label: Vocabulary.name,
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => {
          const message = messages[rowIndex];
          const isLeadUri = message?.source === ClientMessageSource.leadUri;
          return (
            <div style={leadBadgeStyles.container}>
              {isLeadUri && <span style={leadBadgeStyles.badge}>Lead</span>}
              <Typography>{message?.name}</Typography>
            </div>
          );
        },
      },
    },
    {
      name: "email",
      label: Vocabulary.email,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "phone",
      label: Vocabulary.phone,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "message",
      label: Vocabulary.message,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (message: string | undefined) => (
          <Typography>{message && message?.substring(0.2)}...</Typography>
        ),
      },
    },
    {
      name: "status",
      label: Vocabulary.status,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status: StatusModel | undefined) => (
          <Typography>{status?.nume}</Typography>
        ),
      },
    },
    {
      name: "vehicle",
      label: Vocabulary.vehicle,
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => {
          return (
            <>
              {messages[rowIndex]?.vin ? (
                <Typography>
                  {messages[rowIndex].brand} {messages[rowIndex].model}
                  <br />
                  {Vocabulary.vin}: {messages[rowIndex].vin}
                </Typography>
              ) : null}
            </>
          );
        },
      },
    },
    {
      name: "created_at",
      label: Vocabulary.date,
      options: {
        filter: true,
        sort: false,
        downloadType: "date",
        customBodyRender: (date: string | null) => {
          const d = moment.utc(date);
          return (
            <Typography>{d.local().format(europeanDateWithTime)}</Typography>
          );
        },
      },
    },
    {
      name: "first_seen_user",
      label: " ",
      options: {
        sort: false,

        customBodyRender: (first_seen_user: any) => {
          return (
            <div style={{ textAlign: "center", minWidth: 100 }}>
              <Typography style={{ fontSize: 10 }}>
                {Vocabulary.alocatedFor}
              </Typography>
              <Typography style={{ fontWeight: 600, fontSize: 15 }}>
                {first_seen_user?.name}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      name: "cancel_reason",
      label: Vocabulary.cancelReason,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (cancelReason: string | null | undefined) => (
          <Typography>{cancelReason || "-"}</Typography>
        ),
      },
    },
    {
      name: "last_note",
      label: Vocabulary.note,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (note: any) => (
          <Typography>{note?.note || "-"}</Typography>
        )
      }
    },
    {
      name: "next_follow_up",
      label: Vocabulary.followUp,
      options: {
        filter: false,
        sort: true,
        download: false,

        customBodyRenderLite: (rowIndex: number) => {
          const followUp = messages[rowIndex]?.next_follow_up;
          if (!followUp || followUp.completed) return <Typography>-</Typography>;
          const isOverdue = moment(followUp.follow_up_date).isBefore(moment());
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Tooltip title={Vocabulary.markAsCompleted}>
                <Chip
                  size="small"
                  label={`${isOverdue ? Vocabulary.overdueFollowUp : Vocabulary.upcomingFollowUp} – ${moment(followUp.follow_up_date).format("DD/MM HH:mm")}`}
                  color={isOverdue ? "error" : "warning"}
                  deleteIcon={<CheckCircleOutlineIcon />}
                  onDelete={(event) => completeFollowUp(event, followUp.id, messages[rowIndex].id)}
                />
              </Tooltip>
              {followUp.note && (
                <Typography variant="caption" color="text.secondary" style={{ fontSize: 11, paddingLeft: 2 }}>
                  {followUp.note}
                </Typography>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: Vocabulary.options,
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (rowIndex: number) => (
          <div style={{ float: "right" }}>
            <Tooltip title={Vocabulary.edit}>
              <ModeEditIcon
                style={{
                  marginRight: 15,
                  height: 30,
                  cursor: "pointer",
                  color: "#4449",
                }}
                onClick={(event: any) => {
                  event.stopPropagation();
                  openMessage(rowIndex);
                }}
              />
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  // columns
  const columnsAllocated = [
    {
      name: "name",
      label: Vocabulary.name,
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => {
          const message = messages[rowIndex];
          const isLeadUri = message?.source === ClientMessageSource.leadUri;
          return (
            <div style={leadBadgeStyles.container}>
              {isLeadUri && <span style={leadBadgeStyles.badge}>Lead</span>}
              <Typography>{message?.name}</Typography>
            </div>
          );
        },
      },
    },
    {
      name: "email",
      label: Vocabulary.email,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "phone",
      label: Vocabulary.phone,
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "message",
      label: Vocabulary.message,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (message: string | undefined) => (
          <Typography>{message && message?.substring(0.2)}...</Typography>
        ),
      },
    },
    {
      name: "vehicle",
      label: Vocabulary.vehicle,
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (rowIndex: number) => {
          return (
            <>
              {messages[rowIndex]?.vin ? (
                <Typography>
                  {messages[rowIndex].brand} {messages[rowIndex].model}
                  <br />
                  {Vocabulary.vin}: {messages[rowIndex].vin}
                </Typography>
              ) : null}
            </>
          );
        },
      },
    },
    {
      name: "status",
      label: Vocabulary.status,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (status: StatusModel) => (
          <Typography>{status?.nume}</Typography>
        ),
      },
    },
    {
      name: "created_at",
      label: Vocabulary.date,
      options: {
        filter: true,
        sort: false,
        downloadType: "date",
        customBodyRender: (date: string | null) => {
          const d = moment.utc(date);
          return (
            <>
              <Typography>
                {d.local().format(europeanDateWithTime)}
              </Typography>{" "}
            </>
          );
        },
      },
    },
    {
      name: "cancel_reason",
      label: Vocabulary.cancelReason,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (cancelReason: string | null | undefined) => (
          <Typography>{cancelReason || "-"}</Typography>
        ),
      },
    },
    {
      name: "last_note",
      label: Vocabulary.note,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (note: any) => (
          <Typography>{note?.note || "-"}</Typography>
        )
      }
    },
    {
      name: "next_follow_up",
      label: Vocabulary.followUp,
      options: {
        filter: false,
        sort: true,
        download: false,
        setCellHeaderProps: () => ({ style: { fontWeight: "bold" } }),
        customBodyRenderLite: (rowIndex: number) => {
          const followUp = messages[rowIndex]?.next_follow_up;
          if (!followUp || followUp.completed) return <Typography>-</Typography>;
          const isOverdue = moment(followUp.follow_up_date).isBefore(moment());
          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
              <Tooltip title={Vocabulary.markAsCompleted}>
                <Chip
                  size="small"
                  label={`${isOverdue ? Vocabulary.overdueFollowUp : Vocabulary.upcomingFollowUp} – ${moment(followUp.follow_up_date).format("DD/MM HH:mm")}`}
                  color={isOverdue ? "error" : "warning"}
                  deleteIcon={<CheckCircleOutlineIcon />}
                  onDelete={(event) => completeFollowUp(event, followUp.id, messages[rowIndex].id)}
                />
              </Tooltip>
              {followUp.note && (
                <Typography variant="caption" color="text.secondary" style={{ fontSize: 11, paddingLeft: 2 }}>
                  {followUp.note}
                </Typography>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "",
      label: Vocabulary.options,
      options: {
        filter: false,
        sort: false,
        download: false,
        customBodyRenderLite: (rowIndex: number) => (
          <div style={{ float: "right" }}>
            <Tooltip title={Vocabulary.edit}>
              <ModeEditIcon
                style={{
                  marginRight: 15,
                  height: 30,
                  cursor: "pointer",
                  color: "#4449",
                }}
                onClick={(event: any) => {
                  event.stopPropagation();
                  openMessage(rowIndex);
                }}
              />
            </Tooltip>
          </div>
        ),
      },
    },
  ];

  const options: any = {
    rowsPerPage: formState.perPage,
    page: formState.page,
    selectableRows: "none" as any,
    responsive: tableLayoutOnMobile,
    filterType: "dropdown",
    filter: false,
    download: true,
    sort: true,
    serverSide: true,
    sortOrder: { name: formState.sortField, direction: formState.order },
    count: formState?.count,
    viewColumns: false,
    fixedHeader: false,
    fixedSelectColumn: false,
    rowsPerPageOptions: [
      15,
      50,
      100,
      formState?.count > 100 ? formState?.count : 1000,
    ],
    print: false,
    search: false,
    rowHover: false,
    textLabels: {
      body: {
        noMatch: Vocabulary.noData,
      },
      viewColumns: {
        title: Vocabulary.viewColumns,
      },
      toolbar: {
        downloadCsv: Vocabulary.downloadExcel,
        viewColumns: Vocabulary.selectColumns,
      },
    },
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    setTableProps: () => {
      return {
        size: "small",
      };
    },
    setRowProps: (_row: [], _dataIndex: number, rowIndex: number) => {
      let styleProps = {};
      if (messages && !messages[rowIndex]?.first_seen_user_id) {
        styleProps = {
          filter: "blur(5px)",
        };
      }
      if (messages[rowIndex]?.status?.culoare) {
        styleProps = {
          ...styleProps,
          backgroundColor: messages[rowIndex]?.status?.culoare,
        };
      }
      return {
        style: { ...styleProps, cursor: "pointer" },
      };
    },
    onRowClick: (
      rowData: string[],
      rowMeta: { dataIndex: number; rowIndex: number },
    ) => {
      openMessage(rowMeta.rowIndex);
    },
    onChangePage: (page: number) => {
      setFormState({
        ...formState,
        page: page,
      });
      window.scrollTo(0, 0);
    },
    onChangeRowsPerPage: (numberOfRows: number) => {
      setFormState({
        ...formState,
        perPage: numberOfRows,
      });
      window.scrollTo(0, 0);
    },
    onColumnSortChange: (changedColumn: string, direction: string) => {
      setFormState((prev) => ({
        ...prev,
        sortField: changedColumn,
        order: direction,
        page: 0,
      }));
    },
    onDownload: (buildHead: any, buildBody: any, columns: any, data: any) => {
      let indefOfVehicleColumn = 0;
      let indexOfDateColumn = 0;
      columns = columns.map((column: any, index: number) => {
        if (column.name == "vehicle") indefOfVehicleColumn = index;
        else if (column.name == "first_seen_user")
          column.label = Vocabulary.user;
        else if (column.name == "created_at") {
          indexOfDateColumn = index;
        }
        return column;
      });
      const alteredData = data.map((column: any, index: number) => {
        column.data = column?.data?.map((value: any, key: number) => {
          if (typeof value == "object") {
            if (value) {
              const name = Object.values(value)[1];
              value = name;
            }
          }
          if (indefOfVehicleColumn == key) value = messages[index].vin;
          else if (indexOfDateColumn == key)
            value = moment.utc(value).local().format(europeanDateWithTime);
          return value;
        });

        return column;
      });
      return `${buildHead(columns)}${buildBody(alteredData)}`;
    },
  };

  function renderFilterForm() {
    return (
      <>
        <Grid
          container
          spacing={3}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label={Vocabulary.startDate}
                value={moment(formState?.startDate)}
                format={europeanDate}
                minDate={moment(minDate)}
                maxDate={moment(formState?.endDate)}
                onChange={(e: any) => onChangeStartDate(e)}
                slotProps={{ textField: { size: "small", fullWidth: true } }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label={Vocabulary.endDate}
                value={moment(formState?.endDate)}
                minDate={moment(formState?.startDate)}
                maxDate={moment()}
                onChange={(e: any) => onChangeEndDate(e)}
                format={europeanDate}
                slotProps={{ textField: { size: "small", fullWidth: true } }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              onChange={onChange}
              value={formState.vin}
              id="vin"
              name="vin"
              label={Vocabulary.vin}
              variant="outlined"
              size="small"
              inputProps={{
                style: { textTransform: "uppercase" },
              }}
              onKeyUp={onTextFieldKeyUp}
              onBlur={onFilterBlur}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Autocomplete
              size="small"
              getOptionLabel={(option: any) => option?.nume}
              id="brand_id"
              value={formState.brand}
              onChange={(event, value: any) => {
                setFormState({
                  ...formState,
                  brand: value,
                  model: null,
                  page: 0,
                });
              }}
              onBlur={onFilterBlur}
              options={props.cacheContext.cache?.brands}
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="brand_id"
                  label={Vocabulary.brand}
                  name="brand_id"
                />
              )}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Autocomplete
              size="small"
              getOptionLabel={(option: any) => option?.nume}
              id="model_r"
              value={formState.model}
              onChange={(event, value: any) => {
                setFormState({
                  ...formState,
                  model: value,
                  page: 0,
                });
              }}
              onBlur={onFilterBlur}
              options={
                formState.brand
                  ? props.cacheContext.cache?.models.filter(
                      (model: VehicleBrandModel_Model) =>
                        model.brand_id === formState.brand?.id,
                    )
                  : []
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  id="model_id"
                  label={Vocabulary.model}
                  name="model_id"
                />
              )}
            />
          </Grid>
          {(props.status == clientMessagesStatus.Toate ||
            props.status == clientMessagesStatus.Alocate) && ( //have status filtering only at assigned and all messages
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Autocomplete
                size="small"
                multiple
                getOptionLabel={(option: any) => option?.nume}
                id="status_id"
                value={formState.status ? formState.status : []}
                onChange={(event, value: any) => {
                  setFormState({
                    ...formState,
                    status: value,
                    page: 0,
                  });
                }}
                onBlur={onFilterBlur}
                options={
                  props.cacheContext.cache.clientMessagesStatus
                    ? props.cacheContext.cache.clientMessagesStatus
                    : []
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    id="status_id"
                    label={Vocabulary.status}
                    name="status_id"
                  />
                )}
              />
            </Grid>
          )}
          {props.status != clientMessagesStatus.Alocate && (
            <Grid item xs={12} md={12} lg={12}>
              <Autocomplete
                id="filterUsers"
                freeSolo={false}
                disablePortal
                getOptionLabel={(option: any) => option.name}
                isOptionEqualToValue={(option:any, value:any) => option.id == value.id}
                size="small"
                options={assignedUsers}
                value={formState.user}
                onChange={(event: any, newValue: any) =>
                  setFormState({
                    ...formState,
                    user: newValue,
                    page: 0,
                  })
                }
                sx={{ width: "100%" }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={Vocabulary.user}
                    variant="outlined"
                    size="small"
                  />
                )}
              />
            </Grid>
          )}
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              fullWidth
              onChange={onChange}
              value={formState.clientName}
              id="clientName"
              name="clientName"
              label={Vocabulary.client}
              variant="outlined"
              size="small"
              onKeyUp={onTextFieldKeyUp}
              onBlur={onFilterBlur}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={formState.followUpFilter}
                  onChange={(e) =>
                    setFormState({
                      ...formState,
                      followUpFilter: e.target.checked,
                      page: 0,
                    })
                  }
                />
              }
              label={Vocabulary.followUps}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <FormControl size="small" fullWidth>
              <InputLabel>{Vocabulary.order}</InputLabel>
              <Select
                fullWidth
                id="order"
                value={formState.order}
                label={Vocabulary.order}
                name="order"
                onBlur={onFilterBlur}
                onChange={(event: SelectChangeEvent<string>) => {
                  setFormState({
                    ...formState,
                    [event.target.name]: event.target.value,
                    page: 0,
                  });
                }}
              >
                <MenuItem value={"asc"}>{Vocabulary.asc}</MenuItem>
                <MenuItem value={"desc"}>{Vocabulary.desc}</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <LegendComponent
          title={Vocabulary.status}
          data={props.cacheContext.cache.clientMessagesStatus}
        />
      </>
    );
  }

  /**
   *
   * @returns full warning message for desktop
   */
  const getWarningMessage = () => {
    if (getShortWarningMessage())
      return getShortWarningMessage() + getLongWarningMessageVersion();
    else return null;
  };

  /**
   *
   * @returns the long version of warning message only showed oon descktop if automated allocation is on
   */
  const getLongWarningMessageVersion = () => {
    let message = "";
    const isAutomatedAllocationON = props.cacheContext.cache.settings.find(
      (user: any) => user.slug == Settings.automatedClientMessages,
    )?.value;
    if (isAutomatedAllocationON == 1) {
      const maxNrOfMsgs = props.cacheContext.cache.settings.find(
        (user: any) => user.slug == Settings.maxNumberForMessages,
      )?.value;
      message = ` , din ${
        maxNrOfMsgs ? maxNrOfMsgs : DEFAULT_MAX_NUMBER_OF_MESSAGES
      } maxime!`;
    }
    return message;
  };

  /**
   *
   * @returns the warning message to be show to let user know how many unread car orders he has
   * this is the short version to be shown only on mobile and if the automated allocation is off
   */
  const getShortWarningMessage = () => {
    let message = "";
    if (messagesCount) {
      message = `Ai ${messagesCount} `;
      if (messagesCount == 1) {
        message += "mesaj necitit";
      } else {
        message += "mesaje necitite";
      }
    }
    return message;
  };

  /**
   * export table as excel
   */
  const exportData = (props: any) => {
    const statusCode = status === "" ? tabsLabelsArray[0].code : status;

    const statusIds: any[] = [];
    if (formState.status) {
      formState.status.forEach((status) => {
        statusIds.push(status.id);
      });
    }
    let exportedColumns = props?.columns;
    exportedColumns = exportedColumns.filter((column: any) => {
      if (column.download == true) return column.name;
    });

    const fileName = (
      Vocabulary.clientMessages +
      "_" +
      tabsLabelsArray[value]?.label
    ).toLowerCase();

    formState.endDate = moment(formState.endDate).format(anafFormatDate);
    const url = `${urlEnum.clientMessages}/export/table/data`;
    const type = clientMessagesType.contactMessage;
    exportTable(
      url,
      { formState, type, statusCode, statusIds, userId },
      fileName,
      exportedColumns,
    );
  };

  /**
   *
   * @param props
   * @returns
   */
  const CustomToolbar = (props: any) => {
    return (
      <Toolbar>
        <Button
          startIcon={<CloudDownloadIcon />}
          onClick={(event) => exportData(props)}
        >
          {Vocabulary.exportTable}
        </Button>
      </Toolbar>
    );
  };

  return (
    <Grid container spacing={3} style={{ padding: isMobile() ? 0 : 20 }}>
      <Grid item lg={2} md={2} sm={12} xs={12}>
        {isMobile() ? (
          <Accordion
            expanded={openAccordion}
            onChange={() => setOpenAccordion(!openAccordion)}
            style={{ zIndex: 10 }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <TuneIcon style={{ marginRight: 10 }}></TuneIcon>
              <Typography style={{ marginTop: 1 }}>
                {Vocabulary.options}{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>{renderFilterForm()}</AccordionDetails>
          </Accordion>
        ) : (
          renderFilterForm()
        )}
      </Grid>
      <Grid item lg={10} md={10} sm={12} xs={12}>
        <ThemeProvider theme={getMuiTheme()}>
          <DinamicTabs
            name={componentNames.DinamicTabs}
            labels={props.tabsLabelsArray}
            warningMessage={
              getWarningMessage() !== "" ? getWarningMessage() : null
            }
            shortWarningMessage={getShortWarningMessage()}
            value={props.value}
            handleChangeTab={(
              event: React.FormEvent<HTMLInputElement>,
              index: number,
            ) => {
              props.handleChange(event, index);
              setFormState({
                ...formState,
                status: undefined,
                user: null,
                page: 0,
              });
            }}
            hideAddNew={true}
          />
          <div
            style={{
              marginLeft: isMobile() ? -15 : -25,
              marginRight: isMobile() ? -15 : -25,
              marginTop: isMobile() ? -25 : -25,
              width: "auto",
            }}
          >
            <TabPanel value={props.value} index={0}>
              <MUIDataTable
                title=""
                data={messages}
                columns={columns}
                options={options}
                components={{
                  TableToolbar: CustomToolbar,
                }}
              />
            </TabPanel>
            <TabPanel value={props.value} index={1}>
              <MUIDataTable
                title=""
                data={messages}
                columns={columnsAllocated}
                options={options}
                components={{
                  TableToolbar: CustomToolbar,
                }}
              />
            </TabPanel>
            <TabPanel value={props.value} index={2}>
              <MUIDataTable
                title=""
                data={messages}
                columns={columns}
                options={options}
                components={{
                  TableToolbar: CustomToolbar,
                }}
              />
            </TabPanel>
            <TabPanel value={props.value} index={3}>
              <MUIDataTable
                title=""
                data={messages}
                columns={columns}
                options={options}
                components={{
                  TableToolbar: CustomToolbar,
                }}
              />
            </TabPanel>
          </div>
        </ThemeProvider>

      </Grid>
    </Grid>
  );
}
